// 输出版本构建信息到控制台
console.log(
  `%c 构建版本 %c v${process.env.BUILD_VERSION} | ${process.env.BUILD_HASH} | ${process.env.BUILD_TIME}`,
  'background:#35495e;color:#fff;padding:2px 6px;border-radius:3px 0 0 3px;',
  'background:#41b883;color:#fff;padding:2px 6px;border-radius:0 3px 3px 0;'
)

import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './store/'

import { VueAxios } from "@/utils/request"

import Antd from 'ant-design-vue'
import Viser from 'viser-vue'
import 'ant-design-vue/dist/antd.less';  // or 'ant-design-vue/dist/antd.less'
// 系统公共样式
import '@/assets/common.less'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import '@/permission' // permission control
import '@/utils/filter' // base filter
import DictSelectTag from './components/dict/index.js'
import Print from 'vue-print-nb'
import { borderBox9, scrollBoard } from '@jiaminghi/data-view'
Vue.prototype.$EventBus = new Vue();

// 点云查看器
import PcdViewer from '@/components/PcdViewer/index.vue'
const pcdViewerInstance = {
  vm: null,
  show(url, title) {
    if (!this.vm) {
      const vm = new Vue({
        render: h => h(PcdViewer)
      }).$mount()
      document.body.appendChild(vm.$el)
      this.vm = vm.$children[0]
    }
    this.vm.show(url, title)
  }
}
Vue.prototype.$pcdViewer = pcdViewerInstance

Vue.use(borderBox9)
Vue.use(scrollBoard)
/*import '@babel/polyfill'*/

import {
  ACCESS_TOKEN,
  DEFAULT_COLOR,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR_WEAK,
  SIDEBAR_TYPE,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_CONTENT_WIDTH_TYPE
} from "@/store/mutation-types"
import config from '@/defaultSettings'

import hasPermission from '@/utils/hasPermission'

Vue.config.productionTip = false

Vue.use(Storage, config.storageOptions)
Vue.use(Antd)
Vue.use(VueAxios, router)
Vue.use(Viser)
Vue.use(hasPermission)
Vue.use(DictSelectTag)
Vue.use(Print)

new Vue({
  router,
  store,
  mounted() {
    store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true))
    store.commit('TOGGLE_THEME', Vue.ls.get(DEFAULT_THEME, config.navTheme))
    store.commit('TOGGLE_LAYOUT_MODE', Vue.ls.get(DEFAULT_LAYOUT_MODE, config.layout))
    store.commit('TOGGLE_FIXED_HEADER', Vue.ls.get(DEFAULT_FIXED_HEADER, config.fixedHeader))
    store.commit('TOGGLE_FIXED_SIDERBAR', Vue.ls.get(DEFAULT_FIXED_SIDEMENU, config.fixSiderbar))
    store.commit('TOGGLE_CONTENT_WIDTH', Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth))
    store.commit('TOGGLE_FIXED_HEADER_HIDDEN', Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, config.autoHideHeader))
    store.commit('TOGGLE_WEAK', Vue.ls.get(DEFAULT_COLOR_WEAK, config.colorWeak))
    store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
    store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
  },
  render: h => h(App)
}).$mount('#app')
